export const issuanceList = "ISSUANCE_LIST";
export const issuanceEligibleTrainees = "ISSUANCE_ELIGIBLE_TRAINEES";
export const userCertificatesBatch = "USER_CERTIFICATES_BATCH";
